import { createAsyncThunk } from '@reduxjs/toolkit';
import { setChatDialogOpen, setProject } from '../slices/chatSlice';
import { loadThreadOnDemand } from './loadThreadOnDemand';
import { setThreadWithUsers } from './loadThreadUsers';

export const openChatDialogForProject = createAsyncThunk(
  'chat/openChatDialogForProject',
  async ({ project }, { getState, dispatch }) => {
    dispatch(setChatDialogOpen(true));
    const state = getState().chatSlice;
    if (state.project?.id !== project.id) {
      dispatch(setProject(project));
    }
    let thread = null;
    try {
      thread = state.threadsByProject[project.id];
    } catch (error) {
      thread = null;
    }

    if (thread) {
      await dispatch(setThreadWithUsers({ thread }));
    } else {
      const loadedThread = await dispatch(loadThreadOnDemand({ project })).then(
        (result) => result.payload
      );
      await dispatch(setThreadWithUsers({ thread: loadedThread }));
    }
  }
);
